import React, { useReducer } from "react";

const INITIAL_STATE = {
  name: "",
  entity: "",
  category: "",
  market: "",
  llm: "gpt-4o",
  type: "brand",
  loading: false,
  top_products: [],
  is_launched: false,
  abort_launch: false,
  location: "United States",
  product_prefs: [],
  buying_journey_prompts: [],
  discussion_topics: [],
  discussion_topics_loading: false,
  barrier_topics: [],
  barrier_topics_loading: false,
  support_unsupport_topics: [],
  support_unsupport_topics_loading: false,
  buying_journey_prompts_loading: false,
};

export const BuyingJourneyContext = React.createContext({
  location: "",
  product_prefs: [],
  state: {},
  category: "",
  market: "",
  llm: "",
  type: "",
  loading: false,
  updateId: () => {},
  updateLoading: () => {},
  top_products: [],
  updatedTopProducts: () => {},
  name: "",
  entity: "",
  buying_journey_prompts: [],
  updateEntity: () => {},
  updateName: () => {},
  updateType: () => {},
  is_launched: false,
  updatedLaunched: () => {},
  updateEntireState: () => {},
  resetState: () => {},
  updateCategory: () => {},
  updateMarket: () => {},
  updateLLM: () => {},
  abort_launch: false,
  updateAbortLaunch: () => {},
  updateLocation: () => {},
  updateProductPrefs: () => {},
  updateBuyingJourneyPrompts: () => {},
  discussion_topics: [],
  discussion_topics_loading: false,
  barrier_topics: [],
  barrier_topics_loading: false,
  support_unsupport_topics: [],
  support_unsupport_topics_loading: false,
  buying_journey_prompts_loading: false,
  updateBuyingJourneyPromptsLoading: () => {},
  updateSupportTopics: () => {},
  updateSupportTopicsLoading: () => {},
  updateDiscussionTopics: () => {},
  updateDiscussionTopicsLoading: () => {},
  updateBarrierTopics: () => {},
  updateBarrierTopicsLoading: () => {},
});

function discoveryReducer(state = INITIAL_STATE, action) {
  if (action.type === "UPDATE_ENTITY") {
    return {
      ...state,
      entity: action.payload,
    };
  }
  if (action.type === "UPDATE_LAUNCHED") {
    return {
      ...state,
      is_launched: action.payload,
    };
  }
  if (action.type === "UPDATE_STATE") {
    return {
      ...action.payload,
    };
  }
  if (action.type === "RESET_STATE") {
    return {
      ...INITIAL_STATE,
      type: state.type,
    };
  }

  if (action.type === "UPDATE_NAME") {
    return {
      ...state,
      name: action.payload,
    };
  }
  if (action.type === "UPDATE_CATEGORY") {
    return {
      ...state,
      category: action.payload,
    };
  }
  if (action.type === "UPDATE_MARKET") {
    return {
      ...state,
      market: action.payload,
    };
  }
  if (action.type === "UPDATE_LLM") {
    return {
      ...state,
      llm: action.payload,
    };
  }
  if (action.type === "UPDATE_TYPE") {
    return {
      ...state,
      type: action.payload,
    };
  }

  if (action.type === "UPDATE_ID") {
    return {
      ...state,
      id: action.payload,
    };
  }
  if (action.type === "ABORT_LAUNCH") {
    return {
      ...state,
      abort_launch: action.payload,
    };
  }
  if (action.type === "UPDATE_LOCATION") {
    return {
      ...state,
      location: action.payload,
    };
  }

  if (action.type === "UPDATE_PRODUCT_PREFS") {
    return {
      ...state,
      product_prefs: action.payload,
    };
  }

  if (action.type === "UPDATE_LOADING") {
    return {
      ...state,
      loading: action.payload,
    };
  }

  if (action.type === "UPDATE_BUYING_PROMPTS") {
    return {
      ...state,
      buying_journey_prompts: action.payload,
    };
  }

  if (action.type === "UPDATE_BUYING_PROMPTS_LOADING") {
    return {
      ...state,
      buying_journey_prompts_loading: action.payload,
    };
  }

  if (action.type === "UPDATE_SUPPORT_TOPICS") {
    return {
      ...state,
      support_unsupport_topics: action.payload,
    };
  }

  if (action.type === "UPDATE_SUPPORT_TOPICS_LOADING") {
    return {
      ...state,
      support_unsupport_topics_loading: action.payload,
    };
  }

  if (action.type === "UPDATE_DISCUSSION_TOPICS") {
    return {
      ...state,
      discussion_topics: action.payload,
    };
  }

  if (action.type === "UPDATE_DISCUSSION_TOPICS_LOADING") {
    return {
      ...state,
      discussion_topics_loading: action.payload,
    };
  }

  if (action.type === "UPDATE_BARRIER_TOPICS") {
    return {
      ...state,
      barrier_topics: action.payload,
    };
  }

  if (action.type === "UPDATE_BARRIER_TOPICS_LOADING") {
    return {
      ...state,
      barrier_topics_loading: action.payload,
    };
  }

  return state;
}

export default function BuyingJourneyProvider({ children }) {
  const [state, dispatch] = useReducer(discoveryReducer, INITIAL_STATE);

  function updateLoading(payload) {
    dispatch({ type: "UPDATE_LOADING", payload });
  }

  function updateId(payload) {
    dispatch({ type: "UPDATE_ID", payload });
  }

  function updatedTopProducts(payload) {
    dispatch({ type: "UPDATE_TOP_PRODUCTS", payload });
  }

  function updateEntity(payload) {
    dispatch({ type: "UPDATE_ENTITY", payload });
  }

  function updatedLaunched(payload) {
    dispatch({ type: "UPDATE_LAUNCHED", payload });
  }

  function updateEntireState(payload) {
    dispatch({ type: "UPDATE_STATE", payload });
  }

  function resetState() {
    dispatch({ type: "RESET_STATE" });
  }

  function updateName(payload) {
    dispatch({ type: "UPDATE_NAME", payload });
  }

  function updateCategory(payload) {
    dispatch({ type: "UPDATE_CATEGORY", payload });
  }

  function updateMarket(payload) {
    dispatch({ type: "UPDATE_MARKET", payload });
  }

  function updateLLM(payload) {
    dispatch({ type: "UPDATE_LLM", payload });
  }

  function updateType(payload) {
    dispatch({ type: "UPDATE_TYPE", payload });
  }

  function updateLocation(payload) {
    dispatch({ type: "UPDATE_LOCATION", payload });
  }

  function updateBuyingJourneyPrompts(payload) {
    dispatch({ type: "UPDATE_BUYING_PROMPTS", payload });
  }

  function updateBuyingJourneyPromptsLoading(payload) {
    dispatch({ type: "UPDATE_BUYING_PROMPTS_LOADING", payload });
  }

  function updateAbortLaunch(payload) {
    dispatch({ type: "ABORT_LAUNCH", payload });

    setTimeout(() => {
      updateLoading(false);
      updatedLaunched(false);
      resetState();
    }, 100);
  }

  function updateProductPrefs(payload) {
    dispatch({ type: "UPDATE_PRODUCT_PREFS", payload });
  }

  function updateBarrierTopics(payload) {
    dispatch({ type: "UPDATE_BARRIER_TOPICS", payload });
  }
  function updateBarrierTopicsLoading(payload) {
    dispatch({ type: "UPDATE_BARRIER_TOPICS_LOADING", payload });
  }

  function updateDiscussionTopics(payload) {
    dispatch({ type: "UPDATE_DISCUSSION_TOPICS", payload });
  }

  function updateDiscussionTopicsLoading(payload) {
    dispatch({ type: "UPDATE_DISCUSSION_TOPICS_LOADING", payload });
  }

  function updateSupportTopics(payload) {
    dispatch({ type: "UPDATE_SUPPORT_TOPICS", payload });
  }

  function updateSupportTopicsLoading(payload) {
    dispatch({ type: "UPDATE_SUPPORT_TOPICS_LOADING", payload });
  }

  return (
    <BuyingJourneyContext.Provider
      value={{
        state: state,
        updateId,
        location: state.location,
        loading: state.loading,
        updateLoading: updateLoading,
        product_prefs: state.product_prefs,
        top_products: state.top_products,
        entity: state.entity,
        name: state.name,
        category: state.category,
        market: state.market,
        llm: state.llm,
        is_launched: state.is_launched,
        type: state.type,
        abort_launch: state.abort_launch,
        buying_journey_prompts: state.buying_journey_prompts,
        updatedTopProducts,
        updateEntity,
        updateName,
        updatedLaunched,
        updateEntireState,
        resetState,
        updateCategory,
        updateMarket,
        updateLLM,
        updateType,
        updateAbortLaunch,
        updateLocation,
        updateProductPrefs,
        updateBuyingJourneyPrompts,
        discussion_topics: state.discussion_topics,
        discussion_topics_loading: state.discussion_topics_loading,
        barrier_topics: state.barrier_topics,
        barrier_topics_loading: state.barrier_topics_loading,
        support_unsupport_topics: state.support_unsupport_topics,
        support_unsupport_topics_loading:
          state.support_unsupport_topics_loading,
        buying_journey_prompts_loading: state.buying_journey_prompts_loading,
        updateBarrierTopics,
        updateBarrierTopicsLoading,
        updateDiscussionTopics,
        updateDiscussionTopicsLoading,
        updateSupportTopics,
        updateSupportTopicsLoading,
        updateBuyingJourneyPromptsLoading,
      }}
    >
      {children}
    </BuyingJourneyContext.Provider>
  );
}
